var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25 16a1 1 0 00-1 1v10h-4.17v-4a1 1 0 00-1-1H13a1 1 0 00-1 1v4H8V17a1 1 0 10-2 0v11a1 1 0 001 1h6a1 1 0 001-1v-4h3.83v4a1 1 0 001 1H25a1 1 0 001-1V17a1 1 0 00-1-1",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.646 14.257l-13-11.02a1 1 0 00-1.293 0l-13 11.02a.999.999 0 101.293 1.525L16 5.31l12.353 10.472a.994.994 0 001.41-.116.998.998 0 00-.117-1.409",
    fill: props.color
  })));
}

export default SvgIconHome;